import React, { FC } from "react";
import mergeClasses from "classnames";
import useStyles from "./styles";

type Props = {
  rowClassOverride?: string;
}

const DataTableRow: FC<Props> = ({ children, rowClassOverride }) => {
  const classes = useStyles();

  return (
    <div
      className={rowClassOverride
        ? mergeClasses(classes.row, rowClassOverride)
        : classes.row}
    >
      {children}
    </div>
  );
};

export default DataTableRow;
